<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4.justify-content-end
      b-col.my-1
        h4.mb-0#top-page Aprendizaje
      b-col(cols="auto")
        tutorial-modal(view="Aprendizaje")
          template(v-slot:default)
            b-container
              p Preguntas
              p El Chatbot irá agregando preguntas que no ha sabido responder, tu puedes decidir que hacer con ellas.
              p Te sugerirá agregarlos a bloques existentes o puedes crear bloques nuevos para responder esas preguntas.
              p Oraciones
              p Las oraciones son generadas a partir de la interaccion del chatbot con los usuarios.
              p En esta sección puedes decidir si la oración generada es útiil para futuras conversaciones.
    b-tabs
      b-tab(title="Oraciones generadas")
        b-form-row.align-items-center.mt-3.mb-2
          b-col
            h5.mb-0 Oraciones generadas por el chatbot
          b-col(cols="auto")
            b-button(variant="soft-secondary", @click="getKnowledgeStatus(true)", :disabled="loading_feed") Recabar conocimiento
        b-collapse(v-for="feed in knowledge_feed", :key="feed.sentence_id", :id="feed.sentence_id", visible)
          b-card
            b-card.no-shadow.bg-light
              b-form-group(label="¿Esta oración es cierta y aplica para tu negicio?")
                b-form-input.bg-white(placeholder="Oración", :value="feed.text", readonly)
            b-form-row.align-items-center.justify-content-around
              b-col(md="4")
                b-button(variant="soft-success", block, @click="collapseFeed(feed, true)", :disabled="loading_feed") Sí
              b-col(md="4")
                b-button(variant="soft-danger", block, @click="collapseFeed(feed, false)", :disabled="loading_feed") No
        .text-center(v-if="loading_feed")
          b-spinner(variant="primary")
        empty-message(v-else-if="!knowledge_feed.length", :message="learning_status == 'training' ? 'Se está recabando el conocimiento en estos momentos' : 'No hay más oraciones por el momento, puedes Recabar conocimiento nuevo'")
        b-pagination(:value="paginationCurrentPage", @change="loading = true;paginationPageChanged($event, 'getKnowledgeFeed')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount")

      b-tab(title="Oraciones entrenadas")
        h5.mt-3 Oraciones entrenadas
        b-table.table-nowrap(:items="parse_feed", :fields="fields", stacked="sm" show-empty, :busy="loading")
          template(v-slot:empty)
            p.mb-0.text-center.text-help No hay oraciones entrenadas aún
          template(v-slot:table-busy)
            .text-center
              b-spinner(variant="primary")
          template(v-slot:cell(text)="{ item }")
            .text-wrap {{item.text}}
          template(v-slot:cell(valid)="{ item }")
              b-form-checkbox.ml-1(switch, v-model="item.valid", @change="updateFeed(item)") {{item.valid ? 'Oración validada' : 'Oración No validada'}}
        b-pagination(value="1", @change="getKnowledgeValidated", :per-page="10", :total-rows="total_pages")
      b-tab(title="Preguntas sugeridas")
        h5.mt-3 Preguntas sugeridas por el chatbot
        suggestion-block(v-for="suggestion_block in messages", :key="suggestion_block.id", v-bind="suggestion_block", @create-block="toggleNewBlockModal" @get-suggestion="getSuggestions")
        .text-center(v-if="loading")
          b-spinner(variant="primary")
        empty-message(v-if="!messages.length && !loading", message="No hay más preguntas por el momento")

    b-modal(v-model="block_modal", ok-title="Crear", ok-variant="primary", cancel-title="Cancelar", title="Crear nuevo bloque de preguntas", @ok="createBlock", :ok-disabled="loading")
      b-card.no-shadow.bg-light
        b-form-group(label="El bot no pudo responder esta pregunta, ¿Qué quieres hacer con ella?")
          b-form-input.bg-white(v-for="(question, index) in new_block.questions", :key="index" :value="question.value", readonly)
      b-form-group(label="Nombre de bloque")
        b-form-input(v-model="new_block.name", placeholder="Nombre de bloque")
      b-form-group(label="Variantes de respuestas")
        .d-flex.justify-content-md-end.align-items-center.mb-2.flex-wrap
          b-button(variant="soft-success", size="sm", @click="new_block.answers.push({value: '', loading: false})", :disabled="loading")
            .d-flex.align-items-center
              plus-icon.icon-sm.mr-1
              span.mr-1 Agregar
              span.mr-1.hide-on-mobile variante de
              span respuesta
        b-input-group.mb-2(v-for="(answer, index) in new_block.answers", :key="index")
          b-form-input(autocomplete="off", placeholder="Escribe la respuesta", v-model="answer.value")
          b-input-group-append
            b-button(variant="soft-danger", @click="new_block.answers.splice(index, 1)", :disabled="answer.loading")
              b-spinner(small, variant="primary", v-if="answer.loading")
              trash-2-icon.icon-sm(v-else)
    b-modal(v-model="learn_knowledge_modal", ok-title="Recabar", ok-variant="primary", cancel-title="Cancelar", title="Recabar conocimiento", @ok="learnAllKownledge",)
      b-container
        b-form-group(label="Selecciona la fuente de donde se recabará el conocimiento")
          b-form-radio-group(v-model="selected_source", @change="model_id = null")
            b-form-radio(value="agentes") Conversaciones de agentes
            b-form-radio(v-if="platform_accounts.length", value="messenger")
              p.mb-0 Conversaciones de Messenger
                span.ml-2.text-secondary(v-if="platform_accounts.length == 1") ({{platform_accounts[0].label}})
        b-form-group(label="Seleccionar chatbot:", description="Cuenta de messenger de donde se tomarán las conversaciones", v-if="selected_source == 'messenger' && platform_accounts.length > 1")
          treeselect(:options="platform_accounts", placeholder="-- Seleccionar chatbot --", v-model="model_id", v-bind="treeselect_options", :clearable="false")
        b-form-group(label="Rango de fechas")
          date-range-picker.w-100.p-0.my-2(v-bind="calendar_props", v-model="picked_date", :maxDate="$moment().add(1, 'days').format()", @update="dateChange")
            template(v-slot:input="picker", style="width:100%;")
              b-input-group
                b-form-input.readonly-white(placeholder="Seleccionar fecha...", :value="selected_dates", readonly)
                b-input-group-append
                  b-input-group-text
                    calendar-icon.text-secondary.icon-md
</template>

<script>
import {createNamespacedHelpers, mapActions} from "vuex";
const accountController = createNamespacedHelpers('account')
const questionController = createNamespacedHelpers('question')
const suggestionsController = createNamespacedHelpers('suggestion')
import SuggestionBlock from "../../components/suggestionBlock";
import _debounce from "lodash.debounce";

import TutorialModal from '@/components/TutorialModal.vue'
import treeselectOptions from "@/data/treeselect-options";
import Days from "@/data/days";
import Months from "@/data/months";

export default {
  data: () => {
    return {
      treeselect_options: treeselectOptions,
      loading: false,
      loading_feed: false,
      block_modal: false,
      platform_accounts: [],
      knowledge_feed: [],
      validated_feed: [],
      fields: [
          { key: 'text', label: '', thStyle: { display: 'none'}},
          { key: 'valid', label: '', thStyle: { display: 'none'}},
      ],
      model_id: null,
      new_block: {
        name: '',
        questions: [],
        answers: [],
        sugestion_id: null,
      },
      feed: null,
      learn_knowledge_modal: false,
      selected_source: "agentes",
      learning_status: null,
      calendar_props: {
        timePicker: true,
        ranges: false,
        linkedCalendars: false,
        opens: 'center',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        }
      },
      picked_date: {
        startDate: null,
        endDate: null
      },
      page: 1,
      total_pages: 1,
      filter_valid: null
    }
  },
  computed: {
    ...suggestionsController.mapState({
      messages: state => state.messages
    }),
    ...questionController.mapState({
      blocks: state => state.blocks,
      lists: state => state.lists
    }),
    isKonverza () {
      return (new RegExp('^konverza-', 'i')).test(this.getCurrentUser().role_type)
    },
    selected_dates () {
      if(!this.picked_date.startDate || !this.picked_date.endDate) return ''
      return this.$moment(this.picked_date.startDate).format('DD MMM YYYY') + ' - ' + this.$moment(this.picked_date.endDate).format('DD MMM YYYY')
    },
    parse_feed () {
      return this.validated_feed.map(v => {
        v._rowVariant = v.valid ? "success" : "danger"
        return v
      })
    }
  },
  methods: {
    ...mapActions(['platform/get', 'question/create', 'question/lists', 'question/listBlocks', 'suggestion/all', 'suggestion/destroy', 'knowledge/feed', 'knowledge/feedDefault', 'knowledge/feedValidated', 'knowledge/addSentence', 'knowledge/updateSentence', 'knowledge/learnAll', 'knowledge/trainingStatus']),
    getQuestionsBlocks () {
      let self = this
      this.loading = true

      this['question/listBlocks']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getSuggestions () {
      let self = this
      this.loading = true

      this['suggestion/all']({
        account_id: self.$route.params.account_id,
        params: {
          limit: 1
        },
        callback: res => {
          self.loading = false
          if(res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getLists () {
      let self = this
      this.loading = true

      this['question/lists']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getPlatformAccounts () {
      let self = this

      this['platform/get']({
        account_id: self.$route.params.account_id,
        platform_id: 'messenger',
        callback: async (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.platform_accounts = res.resource.map(a =>{
              return {
                id: a.model_id,
                label: a.name
              }
            })
            if(self.platform_accounts.length == 1) {
              self.model_id = self.platform_accounts[0].id
            }
          }
        }
      })
    },
    createBlock () {
      let self = this
      this.loading = true
      let params = {
        account_id: self.$route.params.account_id,
        train: true,
        ...this.new_block
      }

      if(this.isKonverza) {
        params.list = this.lists.map(l => { return l.id })
      }

      this['question/create']({
        ...params,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Bloque creado y la pregunta fue agregada')
            self.deleteSuggestion()
          }
        }
      })
    },
    toggleNewBlockModal (id) {
      let suggestion = this.messages.find(m => m.id == id)
      if(suggestion) {
        this.new_block.questions.push({value: suggestion.text})
        this.new_block.answers.push({value: '', loading: false})
        this.new_block.sugestion_id = id
        this.block_modal = true
      }
    },
    deleteSuggestion () {
      let self = this
      this.loading = true

      this['suggestion/destroy']({
        account_id: self.$route.params.account_id,
        id: self.new_block.sugestion_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.new_block.sugestion_id = null
            self.getSuggestions()
          }
        }
      })
    },
    scrollToTop () {
      this.$scrollTo('#top-page', 500, {
        container: '#top-page',
        offset: -20
      })
    },
    getFeed (show_modal = false) {
      let self = this
      this.loading_feed = true

      this['knowledge/feed']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading_feed = false
          if(res.error) {
            self.$message.error(res.error)
          } else {
            self.feed = res.resource
            if(self.feed) {
              if(self.learning_status == "trained" && show_modal) {
                self.$message.success("Conocimiento recabando.")
              }
            } else {
              self.learn_knowledge_modal = show_modal
            }
          }
        }
      })
    },
    getKnowledgeFeed(show_modal = false) {
      let self = this
      this.loading_feed = true

      this['knowledge/feedDefault']({
        account_id: self.$route.params.account_id,
        params: {
          ...self.paginationParamsObject,
        },
        callback: res => {
          self.loading_feed = false
          if(res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
            self.knowledge_feed = res.resource.slice()
            if(self.knowledge_feed.length) {
              if(self.learning_status == "trained" && show_modal) {
                self.$message.success("Conocimiento recabando.")
              }
            } else {
              self.learn_knowledge_modal = show_modal
            }
          }
        }
      })
    },
    getKnowledgeValidated(page = 1) {
      let self = this
      this.loading = true

      let params = {
        page: page
      }
      if(this.filter_valid != null) {
        params.valid = this.filter_valid
      }

      this['knowledge/feedValidated']({
        account_id: self.$route.params.account_id,
        params: params,
        callback: res => {
          self.loading = false
          if(res.error) {
            self.$message.error(res.error)
          } else {
            self.validated_feed = res.resource.slice()
            self.total_pages = res.total_pages
          }
        }
      })
    },
    collapseFeed(feed, valid) {
      feed.valid = valid
      this.$root.$emit('bv::toggle::collapse', feed.sentence_id)
    },
    learnFeed: _debounce(function (sentence_id) {
      let self = this
      this.loading_feed = true
      let index = this.knowledge_feed.findIndex(f => f.sentence_id === sentence_id)
      if(index < 0) return

      let feed = this.knowledge_feed[index]

      this['knowledge/updateSentence']({
        ...feed,
        callback: res => {
          self.loading_feed = false
          if(res.error) {
            self.$message.error(res.error)
          } else {
            if(feed.valid) {
              self.$message.success('Oración entrenada')
            }
            self.knowledge_feed.splice(index, 1)
            if(!self.knowledge_feed.length) {
              self.getKnowledgeFeed()
            }
          }
        }
      })
    }, 200),
    updateFeed (feed) {
      let self = this
      this['knowledge/updateSentence']({
        ...feed,
        callback: res => {
          if(res.error) {
            self.$message.error(res.error)
          } else {
            if(feed.valid) {
              self.$message.success('Oración entrenada')
            }
          }
        }
      })
    },
    learnAllKownledge () {
      let self = this
      this.loading_feed = true

      this['knowledge/learnAll']({
        account_id: self.$route.params.account_id,
        source: self.selected_source,
        model_id: self.model_id,
        query: {
          init_date: self.picked_date.startDate,
          final_date: self.picked_date.endDate
        },
        callback: res => {
          self.loading_feed = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.learning_status = "training"
          }
        }
      })
    },
    getKnowledgeStatus (show_modal = false) {
      let self = this
      this.loading_feed = true

      this['knowledge/trainingStatus']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading_feed = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.learning_status = res.status
            if(self.learning_status == "training" && show_modal) {
              self.$message.warning("Se está recabando el conocimiento, intenta de nuevo en unos momentos")
            } else {
              self.knowledge_feed = []
              this.resetPaginationData()
              self.getKnowledgeFeed(show_modal)
            }
          }
        }
      })
    },
    dateChange (dates) {
      this.picked_date.startDate = this.$moment(dates.startDate).startOf('day').format()
      this.picked_date.endDate = this.$moment(dates.endDate).endOf('day').format()
    }
  },
  mounted() {
    this.picked_date.startDate = this.$moment().subtract(1, 'months').startOf('day').format()
    this.picked_date.endDate = this.$moment().endOf('day').format()
    this.setPaginationLimit(5)
    this.getPlatformAccounts()
    this.getQuestionsBlocks()
    this.getSuggestions()
    this.getKnowledgeValidated()
    this.getKnowledgeStatus()
    this.getLists()

    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if(!isJustShown) {
        this.learnFeed(collapseId)
      }
    })
  },
  components: { SuggestionBlock, TutorialModal },
  watch: {
    block_modal (val) {
      if(!val) {
        this.new_block.name = ''
        this.new_block.questions = []
        this.new_block.answers = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>